import React from 'react'

interface ITrendIconProps {
  stroke?: string
}

export const AppUpTrendIcon = ({ stroke = '#121212' }: ITrendIconProps) => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.875 10.75L6.5 5.12502L10.0887 8.71371C11.0918 6.74012 12.7535 5.08527 14.9335 4.11464L17.2174 3.0978M17.2174 3.0978L12.2664 1.19727M17.2174 3.0978L15.3169 8.04886"
        stroke={stroke}
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
